import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@okta/okta-vue'

import Login from '../views/Login.vue'

const fb = require('@/firebase')

import store from '@/store'

const CALLBACK_PATH = '/implicit/callback'

const config = {
  clientId: '0oa5dy5ae7kQlpM06357',
  issuer: 'https://myfox.okta.com/oauth2/default',
  redirectUri: `${ process.env.VUE_APP_REDIRECT_URI }${CALLBACK_PATH}`,
  scopes: ['openid', 'profile', 'email'],
  pkce: true
}

Vue.use(Auth, { ...config })
Vue.use(VueRouter)

Vue.config.errorHandler = (err) => {
  console.log('Global error handler:')
  console.log(err)
  if (err.name === 'AuthSdkError' || err.name === 'AuthApiError') {
    router.push('/')
  }
}

const routes = []

// Only include the admin view in development (have to do string comparison here)
if (process.env.VUE_APP_INCLUDE_ADMIN == 'true') {
  routes.push({
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/articles/publish',
    name: 'Article Builder',
    component: () => import(/* webpackChunkName: "article-builder" */ '../views/ArticleBuilder.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stories/publish',
    name: 'Story Builder',
    component: () => import(/* webpackChunkName: "story-builder" */ '../views/StoryBuilder.vue'),
    meta: {
      requiresAuth: true
    }
  })
}

routes.push(
  {
    path: CALLBACK_PATH,
    component: Auth.handleCallback()
  },
  {
    path: '/college-football',
    alias: [
      '/studio-shows',
      '/betting',
      '/nascar'
    ],
    name: 'Story',
    component: () => import(/* webpackChunkName: "story" */ '../views/Story.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stories/*',
    name: 'Story',
    component: () => import(/* webpackChunkName: "story" */ '../views/Story.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stories',
    name: 'Stories',
    component: () => import(/* webpackChunkName: "stories" */ '../views/Stories.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/articles/*',
    name: 'Article',
    component: () => import(/* webpackChunkName: "article" */ '../views/Article.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '*',
    redirect: '/stories'
  }
)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Route guarding is based primarily on Firebase authentication
router.beforeEach(async (to, from, next) => {
  if (to !== from) {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const targetSlug = to.path.replace('/', '')
    if (requiresAuth) {
      console.log(`The route ${targetSlug} requires authorization.`)
  
      fb.getCurrentUser().then(() => {
        store.commit('setFbAuthenticated', true)
        next()
      }).catch((err) => {
        store.commit('setFbAuthenticated', false)
        console.log(err)
        router.push(`/?target=${targetSlug}`)
      })
    } else {
      next()
    }
    // If the callback path contains no token, redirect to login
    if (to.path === '/implicit/callback' && !to.query.code) {
      console.log('No url query.')
      router.push(`/?target=${targetSlug}`)
    }
  }
})

router.afterEach((to) => {
  const body = document.getElementsByTagName('body')[0]
  const application = document.querySelector('.v-application')
  if (to.name) {
    body.className = to.name.toLowerCase()
    if (application) {
      application.classList.remove('dark')
    }
  }
  const classes = (to.path.replaceAll('/', ' ').trim()).split(' ')
  body.classList.add(classes[classes.length-1])
})

export default router
